var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _path3, _g19, _g20, _path4, _path5, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _path6, _path7, _path8, _path9, _g32, _g33, _g34, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _path17, _g42, _path18, _g43, _path19, _g44, _path20, _path21, _path22, _path23, _path24, _g45, _path25, _path26, _path27, _path28, _path29, _g46, _path30, _path31, _path32, _path33, _g47, _path34, _path35, _path36, _g48, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280.919,
    height: 376,
    viewBox: "0 0 280.919 376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(-158.523 -69.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(257.76 69.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(31.281 219.064)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M378.979,301.146l-99.5-57.447a7.777,7.777,0,0,0-7.052,0l-9.031,5.25c-1.937,1.126-1.928,2.956.025,4.084l99.5,57.448a7.781,7.781,0,0,0,7.052,0l9.032-5.249C380.942,304.105,380.931,302.274,378.979,301.146Z",
    transform: "translate(-261.948 -242.852)",
    fill: "gray"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M359.559,113.376l-73.434-42.4c-3.579-2.067-6.808-2.2-9.106-.765l-3.833,2.208,1.548.283a11.448,11.448,0,0,0-1.233,5.467l-.581,204.985c-.024,7.983,5.593,17.71,12.54,21.722l73.435,42.4a11.5,11.5,0,0,0,5.519,1.706l-.43,1.4,3.817-2.2h0l.02-.01h0c2.273-1.307,3.684-4.1,3.7-8.082L372.1,135.1C372.611,125.065,366.507,117.388,359.559,113.376Z",
    transform: "translate(-227.792 -69.262)",
    fill: "#1b1f2d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(40.928 2.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M356.231,115.31,282.8,72.913c-6.948-4.011-12.6-.789-12.623,7.193l-.582,204.987c-.023,7.983,5.593,17.71,12.541,21.721l73.434,42.4c6.948,4.011,12.6.789,12.623-7.194l.582-204.985C369.281,127,363.178,119.322,356.231,115.31Z",
    transform: "translate(-269.592 -71.188)",
    fill: "#31394c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(42.981 5.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M355.311,116.808l-72.468-41.84c-6.074-3.506-11.027-.684-11.046,6.295l-.578,203.853c-.02,6.976,4.9,15.5,10.973,19.006l72.471,41.842c6.071,3.5,11.032.685,11.052-6.292l.578-203.853A22.108,22.108,0,0,0,355.311,116.808Z",
    transform: "translate(-271.219 -73.461)",
    fill: "#1b1f2d"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(44.843 8.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M354.754,118.545l-9.156-5.286c-.562-.324-1.021-.093-1.1.507-.5,3.814-3.563,5.208-7.255,3.075L300.08,95.384c-3.691-2.131-6.739-7.056-7.212-11.43a2.48,2.48,0,0,0-1.093-1.771L282.621,76.9c-5.15-2.973-9.335-.588-9.352,5.329l-.574,202.941c-.016,5.91,4.142,13.119,9.291,16.091l72.134,41.647c5.15,2.972,9.333.58,9.351-5.329l.575-202.942C364.061,128.719,359.9,121.517,354.754,118.545Z",
    transform: "translate(-272.694 -75.618)",
    fill: "#201f20"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(68.95 140.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M318.239,195.466l-24.685-14.253c-.964-.557-1.753-.115-1.757.993a3.857,3.857,0,0,0,1.745,3.022l24.685,14.251c.964.558,1.753.107,1.757-1a3.838,3.838,0,0,0-1.745-3.014",
    transform: "translate(-291.797 -180.973)",
    fill: "#f24b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M324.519,199.093l-6.475-3.738c-.964-.558-1.747-.111-1.749,1a3.837,3.837,0,0,0,1.738,3.017l6.476,3.739c.963.557,1.745.1,1.748-1a3.825,3.825,0,0,0-1.738-3.011",
    transform: "translate(-285.379 -177.269)",
    fill: "#f24b4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(1.933 12.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M326.335,208.511l-30.081-17.367c-.554-.321-1-.066-1,.57a2.186,2.186,0,0,0,1,1.716l30.08,17.367c.546.315.993.061,1-.568a2.187,2.187,0,0,0-.988-1.719",
    transform: "translate(-292.825 -191.005)",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M321.218,212.748l-5.539-3.2c-.548-.315-.993-.061-.994.575a2.178,2.178,0,0,0,.988,1.711l5.538,3.2c.548.315.994.062,1-.568a2.18,2.18,0,0,0-.988-1.719",
    transform: "translate(-287.735 -186.183)",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M316.631,210.1l-20.4-11.777c-.553-.319-1-.066-1,.57a2.181,2.181,0,0,0,.994,1.715l20.4,11.778c.553.319,1,.066,1-.563a2.18,2.18,0,0,0-.994-1.724",
    transform: "translate(-292.831 -189.125)",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M326.6,212.263l-22.2-12.819c-.546-.315-.992-.062-.994.567a2.182,2.182,0,0,0,.988,1.711l22.2,12.819c.554.321,1,.066,1-.563a2.177,2.177,0,0,0-.994-1.715",
    transform: "translate(-290.69 -188.83)",
    fill: "#ff9797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M302.946,198.607l-8.623-4.978c-.545-.315-.992-.062-.994.567a2.182,2.182,0,0,0,.988,1.711l8.623,4.98c.548.315.993.061.994-.568a2.175,2.175,0,0,0-.988-1.711",
    transform: "translate(-293.329 -190.354)",
    fill: "#ff9797"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(64.992 65.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M314.308,122.623c-.254-.146-.507-.274-.757-.389a12.309,12.309,0,0,0-5.352-1.453,3.551,3.551,0,0,0-3.26,2.068,5.638,5.638,0,0,0-.425,2.675c.013.125.019.255.039.4a2.5,2.5,0,0,0-.384-.274,1.889,1.889,0,0,0-1.533-.2c-1.021.353-1.368,1.7-1.541,3.02a23.924,23.924,0,0,0-.023,5.064c.081.888.207,1.788.362,2.7.061.374.129.742.2,1.121-1.142-.44-2.058,1.408-1.107,3.83.873,2.227,1.629,4.655,2.62,5.227a.892.892,0,0,0,.153.073.817.817,0,0,0,.363.044,29.593,29.593,0,0,0,3.648,7.947l-.016,5.713-14.692-.006c-1.487.047-2.489,1.152-2.687,2.959l-1.252,11.679s8.8,9.592,25.219,19.071c14.47,8.354,25.253,10.069,25.253,10.069l-1.189-13.105a11.457,11.457,0,0,0-2.634-6.022l-14.487-16.824.016-5.72a6.532,6.532,0,0,0,3.69-3.71,2.317,2.317,0,0,0,.361.375,1.515,1.515,0,0,0,.154.1c.991.572,1.757-.979,2.64-2.192.949-1.292.087-4.128-1.027-5.054a46.392,46.392,0,0,0-.064-6.153c-.145-2.082-.24-4.891-1.685-7.12-.076-.114-.158-.223-.24-.326a1.392,1.392,0,0,0,.428-.887,4.756,4.756,0,0,0-1.757-3.785,8.72,8.72,0,0,0-1.418-1.017c-.112-.064-.226-.127-.338-.187a2.57,2.57,0,0,0,.083-.675,6.512,6.512,0,0,0-2.062-4.221,7.288,7.288,0,0,0-1.334-1.007,5.432,5.432,0,0,0-1.224-.524,2.007,2.007,0,0,0-.054-.276,4.778,4.778,0,0,0-.893-1.514,6.44,6.44,0,0,0-1.791-1.5",
    transform: "translate(-288.661 -120.777)",
    fill: "#d0d9f2"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(94.285 195.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M323.388,225.548c-6.336-3.66-11.494-.721-11.515,6.567s5.1,16.156,11.441,19.815,11.5.721,11.515-6.562S329.731,229.21,323.388,225.548Z",
    transform: "translate(-311.873 -223.974)",
    fill: "#f24b4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(4.089 9.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M322.513,233.3c-3.5-2.018-5.18-1.84-6.134-1.487a2.342,2.342,0,0,0-1.23,2.509,8.64,8.64,0,0,0,.642,1.7,1.418,1.418,0,0,0,.533.61.664.664,0,0,0,.221.085l2.333.439c.275.053.463-.138.463-.468l.005-1.45c0-.289.134-.486.362-.481a8.534,8.534,0,0,1,2.8,1.023,13.77,13.77,0,0,1,2.794,2.206,1.44,1.44,0,0,1,.363.9l0,1.451a1.491,1.491,0,0,0,.454,1l2.333,2.255a1.077,1.077,0,0,0,.218.168.433.433,0,0,0,.53,0,2.227,2.227,0,0,0,.652-.955,6.569,6.569,0,0,0-1.209-3.917,17.185,17.185,0,0,0-6.126-5.592",
    transform: "translate(-315.113 -231.589)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(62.287 176.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M298.036,210.87c-6.343-3.661-11.5-.722-11.519,6.566s5.1,16.156,11.445,19.818,11.494.721,11.515-6.562S304.374,214.53,298.036,210.87Z",
    transform: "translate(-286.517 -209.295)",
    fill: "#91aaf2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(5.545 5.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M293.419,214.079c-.03-.016-.059-.032-.091-.045a3.224,3.224,0,0,0-1.277-.322c-.587.057-1.243,1.141-1.126,2.62s.593,3.934,3.058,8.2,4.358,5.916,5.583,6.764c.1.068.2.133.3.191,1.126.651,2.227.6,2.54.165a3.111,3.111,0,0,0,.365-1.257,1.4,1.4,0,0,0-.37-1.011l-2.2-2.529a1.246,1.246,0,0,0-.3-.251.483.483,0,0,0-.48-.048l-.9.511a.484.484,0,0,1-.477-.044,1.069,1.069,0,0,1-.2-.155,19.509,19.509,0,0,1-2.337-3.209,19.73,19.73,0,0,1-1.609-3.621.583.583,0,0,1,.173-.683l.893-.514c.207-.114.256-.448.131-.819l-1.085-3.165a1.486,1.486,0,0,0-.6-.782",
    transform: "translate(-290.911 -213.708)",
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(83.167 28.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M316.537,99.071l-12.822-7.4c-.362-.209-.651-.044-.652.372a1.416,1.416,0,0,0,.649,1.113l12.822,7.4c.356.206.65.044.651-.363a1.426,1.426,0,0,0-.647-1.122",
    transform: "translate(-303.063 -91.577)",
    fill: "#31394c"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(100.027 37.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M317.637,99.348c-.671-.386-1.211-.077-1.214.693a2.649,2.649,0,0,0,1.206,2.081c.663.384,1.211.078,1.214-.684a2.668,2.668,0,0,0-1.206-2.09",
    transform: "translate(-316.423 -99.181)",
    fill: "#31394c"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(100.299 38.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M317.578,99.591c-.519-.3-.938-.062-.939.535a2.049,2.049,0,0,0,.933,1.61c.514.3.931.057.933-.533a2.044,2.044,0,0,0-.926-1.613",
    transform: "translate(-316.639 -99.461)",
    fill: "#1b1f2d"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(101.016 39.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M317.427,100.225c-.124-.072-.218-.016-.22.125a.471.471,0,0,0,.218.37c.117.067.212.013.213-.121a.469.469,0,0,0-.212-.374",
    transform: "translate(-317.207 -100.193)",
    fill: "#31394c"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(44.843 17.906)",
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M345.535,111.207c-.562-.324-1.021-.093-1.1.507-.5,3.814-3.563,5.208-7.255,3.075L300.016,93.332a16.3,16.3,0,0,1-6.942-9.881L273.153,98.613l-.216,75.913,78.624-59.841Z",
    transform: "translate(-272.63 -83.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M272.869,197.717l-.047,16.419,91.121-69.353.046-16.419Z",
    transform: "translate(-272.66 -71.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M272.694,260.984c-.016,5.91,4.142,13.119,9.291,16.091l21.625,12.487,60.057-45.711.215-75.913-91.12,69.354Z",
    transform: "translate(-272.694 -61.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M330.083,288.66l21.611-16.449.046-16.419-33.9,25.8Z",
    transform: "translate(-260.867 -38.304)",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(153.338 153.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M370.771,202.5l-11.387-6.572c-.382-.221-.692-.038-.693.4a1.513,1.513,0,0,0,.689,1.191l11.385,6.575c.382.221.7.049.7-.391a1.543,1.543,0,0,0-.694-1.205",
    transform: "translate(-358.662 -189.583)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M375.542,208.108l-16.166-9.333c-.382-.221-.692-.044-.692.395a1.532,1.532,0,0,0,.686,1.2l16.166,9.332c.384.221.693.037.694-.4a1.51,1.51,0,0,0-.689-1.193",
    transform: "translate(-358.664 -188.836)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M381.989,211.83l-6.913-3.992c-.382-.221-.7-.049-.7.391a1.541,1.541,0,0,0,.7,1.205l6.913,3.99c.382.221.7.042.7-.4a1.525,1.525,0,0,0-.7-1.2",
    transform: "translate(-354.553 -186.462)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M365.133,204.955l-5.763-3.328c-.384-.221-.692-.045-.693.395a1.509,1.509,0,0,0,.688,1.193l5.765,3.328c.382.221.692.045.693-.4a1.51,1.51,0,0,0-.689-1.193",
    transform: "translate(-358.666 -188.089)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M377.83,212.284l-11.5-6.64c-.384-.221-.7-.049-.7.391a1.527,1.527,0,0,0,.7,1.2l11.5,6.64c.384.221.693.045.694-.4a1.51,1.51,0,0,0-.689-1.193",
    transform: "translate(-356.845 -187.037)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M369.188,210.145l-9.827-5.672c-.382-.222-.692-.038-.693.4a1.508,1.508,0,0,0,.689,1.193l9.826,5.674c.384.221.692.045.693-.395a1.519,1.519,0,0,0-.688-1.2",
    transform: "translate(-358.668 -187.343)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M372.842,212.255l-3.234-1.868c-.384-.221-.692-.037-.693.4a1.512,1.512,0,0,0,.688,1.191l3.234,1.868c.384.221.692.045.693-.4a1.528,1.528,0,0,0-.688-1.2",
    transform: "translate(-355.984 -185.794)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M379.448,207.506l-9.1-5.255c-.382-.221-.692-.037-.693.4a1.514,1.514,0,0,0,.689,1.193l9.1,5.254c.384.221.7.049.7-.39a1.543,1.543,0,0,0-.7-1.205",
    transform: "translate(-355.79 -187.925)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M375.86,200.272l-16-9.235c-.636-.367-1.157-.069-1.158.669a2.545,2.545,0,0,0,1.151,2l16,9.235c.642.371,1.164.073,1.166-.658a2.55,2.55,0,0,0-1.158-2.007",
    transform: "translate(-358.658 -190.879)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M381.7,203.64l-5.991-3.458c-.642-.371-1.164-.074-1.166.665a2.547,2.547,0,0,0,1.158,2l5.991,3.458c.642.371,1.164.074,1.166-.656a2.554,2.554,0,0,0-1.158-2.008",
    transform: "translate(-354.51 -188.484)",
    fill: "#1b1f2d"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(153.031 179.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M370.526,223.427l-11.385-6.574c-.382-.221-.692-.037-.693.4a1.51,1.51,0,0,0,.689,1.193l11.385,6.574c.382.221.7.049.7-.391a1.537,1.537,0,0,0-.7-1.2",
    transform: "translate(-358.418 -210.514)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M375.3,229.038,359.133,219.7c-.384-.22-.692-.044-.693.4a1.534,1.534,0,0,0,.688,1.2l16.166,9.332c.384.221.693.038.694-.4a1.515,1.515,0,0,0-.689-1.193",
    transform: "translate(-358.42 -209.767)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M381.745,232.761l-6.914-3.992c-.381-.221-.7-.049-.7.391a1.541,1.541,0,0,0,.7,1.2l6.912,3.992c.384.221.7.04.7-.4a1.523,1.523,0,0,0-.7-1.2",
    transform: "translate(-354.309 -207.393)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M364.889,225.886l-5.765-3.328c-.382-.222-.691-.045-.693.394a1.512,1.512,0,0,0,.688,1.193l5.766,3.329c.382.22.692.044.693-.395a1.513,1.513,0,0,0-.689-1.193",
    transform: "translate(-358.422 -209.02)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M377.586,233.214l-11.5-6.64c-.382-.221-.7-.048-.7.391a1.527,1.527,0,0,0,.7,1.2l11.5,6.64c.382.221.693.045.694-.4a1.517,1.517,0,0,0-.689-1.193",
    transform: "translate(-356.601 -207.968)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M368.944,231.075l-9.827-5.673c-.382-.221-.692-.037-.693.4a1.51,1.51,0,0,0,.689,1.193l9.826,5.674c.384.22.691.044.693-.395a1.53,1.53,0,0,0-.688-1.2",
    transform: "translate(-358.424 -208.274)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M372.6,233.185l-3.233-1.866c-.384-.222-.692-.038-.693.4a1.514,1.514,0,0,0,.688,1.193l3.234,1.866c.382.222.692.045.693-.394a1.528,1.528,0,0,0-.689-1.2",
    transform: "translate(-355.74 -206.725)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M379.2,228.437l-9.1-5.255c-.384-.221-.692-.038-.693.4a1.51,1.51,0,0,0,.689,1.193l9.1,5.255c.382.221.7.049.7-.391a1.538,1.538,0,0,0-.7-1.2",
    transform: "translate(-355.546 -208.856)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M375.616,221.2l-16-9.234c-.636-.367-1.157-.071-1.159.669a2.541,2.541,0,0,0,1.151,1.994l16,9.235c.642.371,1.164.074,1.166-.656a2.554,2.554,0,0,0-1.158-2.008",
    transform: "translate(-358.414 -211.81)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M381.452,224.571l-5.991-3.459c-.642-.371-1.163-.074-1.166.665a2.545,2.545,0,0,0,1.159,2l5.99,3.459c.642.371,1.164.073,1.166-.657a2.55,2.55,0,0,0-1.159-2.007",
    transform: "translate(-354.266 -209.415)",
    fill: "#1b1f2d"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(154.084 116.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M361.69,182.966a2.011,2.011,0,0,1-.912-1.583l.048-16.877c0-.582.413-.817.919-.524l21.321,12.309a2.013,2.013,0,0,1,.914,1.583l-.048,16.877c0,.582-.414.817-.919.525l-12.665-7.312a1.737,1.737,0,0,0-1.713-.185l-3.689,2.017.005-2.145a5.364,5.364,0,0,0-2.425-4.2l-.835-.482m21.38-8.419-21.322-12.309c-1.339-.774-2.437-.149-2.441,1.391l-.048,16.879a5.357,5.357,0,0,0,2.427,4.2l.834.482a2.014,2.014,0,0,1,.912,1.581l-.008,2.318a3.227,3.227,0,0,0,.893,2.065,2.477,2.477,0,0,0,.559.451,1.039,1.039,0,0,0,1.02.109l3.8-2.08a.672.672,0,0,1,.644.073l12.664,7.311c1.341.775,2.439.149,2.443-1.391l.048-16.879a5.361,5.361,0,0,0-2.427-4.2",
    transform: "translate(-359.259 -161.906)",
    fill: "#f7ff0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M364.916,171.353c-1.1-.635-2-.122-2,1.142a4.394,4.394,0,0,0,1.99,3.448c1.1.635,1.993.119,2-1.146a4.379,4.379,0,0,0-1.984-3.444",
    transform: "translate(-358.302 -159.503)",
    fill: "#f7ff0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M370.075,174.332c-1.1-.636-2-.124-2,1.141a4.394,4.394,0,0,0,1.99,3.448c1.1.636,2,.124,2-1.142a4.392,4.392,0,0,0-1.99-3.446",
    transform: "translate(-356.951 -158.722)",
    fill: "#f7ff0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M375.233,177.31c-1.1-.636-2-.124-2,1.142a4.389,4.389,0,0,0,1.991,3.446c1.1.636,2,.124,2-1.142a4.393,4.393,0,0,0-1.99-3.446",
    transform: "translate(-355.599 -157.942)",
    fill: "#f7ff0a"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(6.262 104.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M244.553,173.126a2.014,2.014,0,0,1-.914-1.581l.048-16.877c0-.582.413-.817.92-.525l21.321,12.31a2.014,2.014,0,0,1,.914,1.581l-.048,16.879c0,.581-.413.815-.92.524l-12.664-7.312a1.739,1.739,0,0,0-1.711-.186l-3.691,2.017.006-2.145a5.364,5.364,0,0,0-2.427-4.2l-.834-.482m21.38-8.419L244.612,152.4c-1.34-.774-2.438-.149-2.443,1.392l-.047,16.877a5.364,5.364,0,0,0,2.426,4.2l.834.481a2.014,2.014,0,0,1,.914,1.583l-.006,2.317a3.214,3.214,0,0,0,.891,2.066,2.44,2.44,0,0,0,.56.449,1.045,1.045,0,0,0,1.021.11l3.8-2.08a.672.672,0,0,1,.644.072l12.664,7.312c1.34.774,2.438.148,2.443-1.392l.047-16.877a5.362,5.362,0,0,0-2.425-4.2",
    transform: "translate(-242.122 -152.066)",
    fill: "#546fbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M247.779,161.514c-1.1-.636-2-.124-2,1.141a4.391,4.391,0,0,0,1.99,3.448c1.1.636,1.993.12,2-1.146a4.382,4.382,0,0,0-1.984-3.443",
    transform: "translate(-241.165 -149.663)",
    fill: "#546fbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M252.936,164.492c-1.1-.635-2-.124-2,1.142a4.388,4.388,0,0,0,1.99,3.446c1.1.636,2,.124,2-1.141a4.392,4.392,0,0,0-1.991-3.448",
    transform: "translate(-239.813 -148.882)",
    fill: "#546fbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M258.1,167.471c-1.1-.636-2-.125-2,1.141a4.4,4.4,0,0,0,1.99,3.448c1.1.635,2,.124,2-1.142a4.39,4.39,0,0,0-1.989-3.446",
    transform: "translate(-238.462 -148.102)",
    fill: "#546fbf"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(0 40.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M254.459,141.713c-8.521-4.919-15.433-16.889-15.4-26.68s6.985-13.754,15.5-8.835,15.432,16.89,15.4,26.68-6.977,13.758-15.5,8.835m.106-37.7c-9.566-5.522-17.373-1.066-17.4,9.927s7.726,24.434,17.293,29.959,17.38,1.07,17.411-9.923-7.726-24.435-17.3-29.963",
    transform: "translate(-237.16 -101.642)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M251.194,107.89c-.405-.235-.748-.061-.763.409l-.4,13.015a1.076,1.076,0,0,0-.056.409,2.368,2.368,0,0,0,.395,1.165,2.292,2.292,0,0,0,.771.8c.016.01.032.018.048.027a.994.994,0,0,0,.28.107l9.281,4.941c.39.209.719.038.734-.418a1.663,1.663,0,0,0-.729-1.326l-8.5-5.293-.3-12.545a1.7,1.7,0,0,0-.737-1.275l-.025-.015",
    transform: "translate(-233.803 -100.033)",
    fill: "#1b1f2d"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(1.073 81.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M241.607,134.644a3.753,3.753,0,0,0-1.859-.6,1.5,1.5,0,0,0-1.271.716,3.661,3.661,0,0,0-.467,2.028l2.219,1.281v-.221a1.943,1.943,0,0,1,.271-1.045c.186-.281.563-.259,1.146.078a2.524,2.524,0,0,1,1.012,1.035,2.746,2.746,0,0,1,.328,1.276,1.638,1.638,0,0,1-.342,1.058,2.638,2.638,0,0,1-.856.664c-.347.163-.847.351-1.494.578-.138.044-.276.088-.415.14s-.284.11-.447.167l-1.331.548-.006,2.2,7.071,4.082.006-2.25-4.146-2.394v-.08l1.355-.525.315-.117a7.27,7.27,0,0,0,1.239-.567,2.54,2.54,0,0,0,.833-.871,3,3,0,0,0,.351-1.547,5.537,5.537,0,0,0-.418-2.08,7.015,7.015,0,0,0-1.209-2,7.327,7.327,0,0,0-1.888-1.559",
    transform: "translate(-238.01 -134.048)",
    fill: "#ffef09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M246.985,144.722l2.144-2.622-.01,3.854-2.134-1.232m4.373-4.4-2.841-1.641-3.821,4.837-.005,1.888,4.422,2.563-.008,2.735,2.219,1.281.009-2.735,1.189.687.006-1.959-1.19-.686.02-6.97",
    transform: "translate(-236.26 -132.835)",
    fill: "#ffef09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M258.883,143.413l-2.118-1.224-5.091,13.568,2.118,1.223,5.091-13.567",
    transform: "translate(-234.431 -131.915)",
    fill: "#ffef09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M265.1,148.712l-7.048-4.069-.006,2.346,4.944,2.855v.106l-3.926,6.755v.2l2.38,1.374,3.649-6.924.007-2.647",
    transform: "translate(-232.761 -131.273)",
    fill: "#ffef09"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(158.523 220.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(3.289 12.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(0 91.799)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M366.011,353.592,227.347,273.533a10.84,10.84,0,0,0-9.828,0l-54.374,31.6c-2.7,1.57-2.685,4.122.037,5.693L301.848,390.88a10.833,10.833,0,0,0,9.827,0l54.374-31.6C368.748,357.714,368.735,355.164,366.011,353.592Z",
    transform: "translate(-161.129 -272.354)",
    fill: "gray"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(5.956 22.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(4.745 2.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M173.375,323.384l-.226-79.713,32.662-18.85L227,292.427l-53.63,30.957m35.043-104.129-38.809,22.4.25,87.819,61.907-35.735Z",
    transform: "translate(-169.609 -219.255)",
    fill: "#31394c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M215.5,289.971l4.755,1.3-21.186-67.607-3.686,2.123Z",
    transform: "translate(-158.112 -215.357)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M172.583,304.41l.01,4.055,53.631-30.95-4.77-1.308Z",
    transform: "translate(-164.084 -201.594)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M165.849,234.836l4.745,2.743.25,87.812-4.745-2.742Z",
    transform: "translate(-165.849 -212.431)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M165.849,239.487l4.745,2.743,38.813-22.405-4.745-2.743Z",
    transform: "translate(-165.849 -217.082)",
    fill: "#1b1f2d"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(135.149 96.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(4.745 2.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M275.75,382.338l-.226-79.712,32.663-18.851,21.193,67.607L275.75,382.338M310.794,278.21l-38.81,22.4.25,87.819,61.907-35.735Z",
    transform: "translate(-271.984 -278.21)",
    fill: "#31394c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M317.873,348.926l4.756,1.3L301.443,282.62l-3.686,2.123Z",
    transform: "translate(-260.487 -274.313)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M274.959,363.364l.01,4.055L328.6,336.47l-4.769-1.307Z",
    transform: "translate(-266.459 -260.549)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M268.224,293.791l4.746,2.743.25,87.812-4.745-2.742Z",
    transform: "translate(-268.224 -271.386)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M268.224,298.442l4.746,2.743,38.813-22.406-4.746-2.742Z",
    transform: "translate(-268.224 -276.037)",
    fill: "#1b1f2d"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M368.063,283.152l-2.563.409L227.347,203.8a10.84,10.84,0,0,0-9.828,0L163.235,235.34l-2.1-.8-.006,3.693h0v.045h0a3.516,3.516,0,0,0,2.048,2.8l138.667,80.058a10.837,10.837,0,0,0,9.827,0l54.374-31.6a3.345,3.345,0,0,0,2-3l.011.006C368.043,286.426,368.063,283.152,368.063,283.152Z",
    transform: "translate(-161.129 -198.823)",
    fill: "#a6bfff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M281.481,306.655l54.374-31.6a3.345,3.345,0,0,0,2-3l.011.006c-.02-.13,0-3.4,0-3.4l-2.563.409-19.278-11.131L276.39,297.577v10.243A10.079,10.079,0,0,0,281.481,306.655Z",
    transform: "translate(-130.935 -184.331)",
    fill: "#91aaf2"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M366.011,280.847,227.347,200.79a10.836,10.836,0,0,0-9.828,0l-54.374,31.6c-2.7,1.57-2.685,4.12.037,5.693l138.667,80.059a10.841,10.841,0,0,0,9.827,0l54.374-31.6C368.748,284.971,368.735,282.42,366.011,280.847Z",
    transform: "translate(-161.129 -199.61)",
    fill: "#cfdeff"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(8.453 26.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M180.034,221.269a2.815,2.815,0,0,0-2.48.035l-9.2,5.348a.778.778,0,0,0,.008,1.473l13.562,7.83a2.8,2.8,0,0,0,2.543,0l9.2-5.349c.68-.4.7-1.027.053-1.436a.889.889,0,0,1,.461.649l-11.618-.8.859,7.227a3.219,3.219,0,0,1-.7-.029l-.864-7.246-1.29-.088-.158-.748-12.51-.474a.61.61,0,0,1-.052-.405l12.477.473-1.412-6.725a2.592,2.592,0,0,1,1.118.264m13.656,7.882.02.013-.02-.013m-13.624-7.865-.027-.015.027.015",
    transform: "translate(-167.828 -220.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M182.561,227.722l-.7-.048.864,7.246a3.219,3.219,0,0,0,.7.029l-.859-7.227m-2.235-1.291-12.477-.473a.61.61,0,0,0,.052.405l12.51.474-.085-.406",
    transform: "translate(-167.826 -219.7)",
    fill: "#eef4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M191.356,229.132,177.8,221.3l-.032-.018-.026-.015-.005,0a2.592,2.592,0,0,0-1.118-.264l1.412,6.725.085.406.158.748,1.29.088.7.048,11.618.8a.889.889,0,0,0-.461-.649l-.01-.006-.02-.013-.032-.018",
    transform: "translate(-165.526 -220.997)",
    fill: "#eef4ff"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(27.735 16.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M195.313,213.105a2.819,2.819,0,0,0-2.48.034l-9.2,5.349a.778.778,0,0,0,.009,1.473l13.561,7.829a2.8,2.8,0,0,0,2.544,0l9.2-5.348c.681-.4.7-1.027.053-1.436a.889.889,0,0,1,.462.649l-11.619-.8.861,7.226a3.069,3.069,0,0,1-.7-.029l-.864-7.246-1.29-.088-.158-.747-12.51-.474a.618.618,0,0,1-.053-.405l12.478.473-1.412-6.725a2.592,2.592,0,0,1,1.118.264m13.656,7.882.019.013-.019-.013m-13.624-7.866-.027-.014.027.014",
    transform: "translate(-183.106 -212.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M197.839,219.558l-.7-.049.864,7.246a3.069,3.069,0,0,0,.7.029l-.861-7.226m-2.234-1.291-12.478-.473a.618.618,0,0,0,.053.405l12.51.474-.085-.406",
    transform: "translate(-183.105 -211.536)",
    fill: "#eef4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M206.635,220.967l-13.561-7.829-.032-.018-.026-.014-.005,0a2.592,2.592,0,0,0-1.118-.264l1.412,6.725.085.406.158.747,1.29.088.7.049,11.619.8A.889.889,0,0,0,206.7,221l-.01-.006-.019-.013-.032-.019",
    transform: "translate(-180.805 -212.833)",
    fill: "#eef4ff"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(47.016 6.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M210.592,204.941a2.819,2.819,0,0,0-2.48.034l-9.2,5.348a.779.779,0,0,0,.009,1.474l13.561,7.829a2.8,2.8,0,0,0,2.543,0l9.2-5.348c.68-.4.7-1.027.053-1.437a.888.888,0,0,1,.461.649l-11.618-.8.861,7.227a3.081,3.081,0,0,1-.7-.029l-.863-7.246-1.291-.088-.156-.747-12.51-.476a.607.607,0,0,1-.053-.4l12.477.473-1.412-6.725a2.561,2.561,0,0,1,1.119.264m13.654,7.882.02.013-.02-.013m-13.624-7.866-.026-.014.026.014",
    transform: "translate(-198.385 -204.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M213.118,211.393l-.7-.048.863,7.246a3.081,3.081,0,0,0,.7.029l-.861-7.227m-2.235-1.29-12.477-.473a.607.607,0,0,0,.053.4l12.51.476-.086-.406",
    transform: "translate(-198.384 -203.372)",
    fill: "#eef4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M221.914,212.8l-13.561-7.829-.033-.018-.026-.014,0,0a2.562,2.562,0,0,0-1.119-.264l1.412,6.725.086.406.156.747,1.291.088.7.048,11.618.8a.888.888,0,0,0-.461-.649l-.01-.005-.02-.013-.03-.019",
    transform: "translate(-196.084 -204.669)",
    fill: "#eef4ff"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(137.111 76.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M311.375,271.13l-18.5-10.682-23.094,13.421,18.5,10.682Z",
    transform: "translate(-269.778 -260.447)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(5.508 3.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M297.172,273.5,282.9,265.258l-.277.161,14.267,8.237.279-.161",
    transform: "translate(-271.92 -262.729)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M296.226,274.045l-14.267-8.237-.279.161,14.267,8.237.279-.161",
    transform: "translate(-272.168 -262.585)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M295.279,274.595l-14.267-8.237-.279.162L295,274.756l.277-.161",
    transform: "translate(-272.416 -262.441)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M294.333,275.145l-14.269-8.237-.275.159,14.267,8.238.276-.16",
    transform: "translate(-272.663 -262.297)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M293.39,275.692l-14.267-8.237-.279.161,14.269,8.237.277-.162",
    transform: "translate(-272.911 -262.153)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M292.444,276.242,278.176,268l-.277.161,14.267,8.237.279-.161",
    transform: "translate(-273.159 -262.009)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M291.5,276.792l-14.267-8.237-.279.161,14.267,8.237.279-.162",
    transform: "translate(-273.407 -261.865)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M290.551,277.342,276.284,269.1l-.275.16,14.267,8.237.275-.16",
    transform: "translate(-273.654 -261.721)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M289.606,277.892l-14.268-8.237-.275.16,14.267,8.237.276-.16",
    transform: "translate(-273.902 -261.577)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M281.234,274.224l-6.813-3.933-.279.161,6.813,3.934.279-.163",
    transform: "translate(-274.143 -261.41)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M294.247,267.787l-7.85-4.533-.754.438,7.852,4.534.753-.439",
    transform: "translate(-271.13 -263.254)",
    fill: "#f24b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M289.853,266.489l-4.527-2.614-.532.311,4.527,2.613.532-.309",
    transform: "translate(-271.352 -263.091)",
    fill: "#546fbf"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(137.491 76.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M311.674,270.705l-18.5-10.684-23.094,13.421,18.5,10.682Z",
    transform: "translate(-270.079 -260.022)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(5.508 3.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M297.472,273.069,283.2,264.832l-.279.162,14.268,8.238.277-.163",
    transform: "translate(-272.221 -262.303)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M296.526,273.619l-14.269-8.237-.277.161,14.267,8.237.279-.161",
    transform: "translate(-272.469 -262.159)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M295.58,274.169l-14.267-8.237-.279.162L295.3,274.33l.279-.161",
    transform: "translate(-272.717 -262.015)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M294.633,274.719l-14.267-8.237-.275.16,14.267,8.237.275-.16",
    transform: "translate(-272.964 -261.871)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M293.69,275.268l-14.267-8.238-.279.163,14.267,8.237.279-.161",
    transform: "translate(-273.212 -261.728)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M292.744,275.817l-14.267-8.237-.279.161,14.269,8.237.277-.162",
    transform: "translate(-273.46 -261.583)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M291.8,276.367l-14.268-8.238-.277.163,14.267,8.237.279-.162",
    transform: "translate(-273.707 -261.439)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M290.852,276.917l-14.267-8.238-.276.16,14.268,8.237.275-.159",
    transform: "translate(-273.955 -261.295)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M289.905,277.466l-14.267-8.237-.275.16,14.267,8.237.275-.16",
    transform: "translate(-274.202 -261.151)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M281.534,273.8l-6.814-3.934-.277.162,6.813,3.934.279-.162",
    transform: "translate(-274.443 -260.985)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M294.548,267.362l-7.852-4.534-.753.439,7.851,4.533.753-.438",
    transform: "translate(-271.431 -262.828)",
    fill: "#f24b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M290.154,266.063l-4.526-2.614-.534.311,4.527,2.613.534-.309",
    transform: "translate(-271.653 -262.665)",
    fill: "#546fbf"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(132.391 75.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M307.635,270.343l-18.5-10.682-23.094,13.421,18.5,10.682Z",
    transform: "translate(-266.038 -259.661)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(5.507 3.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M293.432,272.709l-14.267-8.237-.279.161,14.267,8.237.278-.162",
    transform: "translate(-268.18 -261.943)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M292.485,273.259l-14.267-8.237-.279.161,14.269,8.237.277-.161",
    transform: "translate(-268.428 -261.799)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M291.54,273.809l-14.268-8.237-.277.161,14.267,8.237.278-.162",
    transform: "translate(-268.675 -261.655)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M290.593,274.358l-14.267-8.237-.276.16,14.268,8.237.275-.16",
    transform: "translate(-268.923 -261.511)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M289.651,274.907l-14.269-8.239-.279.163,14.269,8.237.279-.161",
    transform: "translate(-269.171 -261.367)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M288.7,275.456l-14.269-8.237-.277.163,14.267,8.237.279-.163",
    transform: "translate(-269.418 -261.223)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M287.758,276.007l-14.267-8.238-.279.163,14.267,8.237.279-.161",
    transform: "translate(-269.666 -261.079)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M286.811,276.556l-14.267-8.237-.275.16,14.267,8.237.275-.16",
    transform: "translate(-269.913 -260.935)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M285.866,277.105,271.6,268.868l-.275.16,14.267,8.237.276-.16",
    transform: "translate(-270.161 -260.791)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M277.493,273.439l-6.813-3.934-.279.161,6.813,3.934.279-.161",
    transform: "translate(-270.402 -260.624)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M290.507,267l-7.85-4.534-.754.439,7.852,4.533.753-.437",
    transform: "translate(-267.39 -262.468)",
    fill: "#f24b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M286.114,265.7l-4.526-2.614-.534.311,4.527,2.613.534-.309",
    transform: "translate(-267.612 -262.305)",
    fill: "#546fbf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(67.674 15.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(0 27.156)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M274.5,257.622l-21.559,12.514a1.711,1.711,0,0,1-1.719,0l-35.614-20.726a1.715,1.715,0,0,1,.005-2.967L237.4,233.784a1.714,1.714,0,0,1,1.719,0l35.266,22.285C275.324,256.6,275.264,257.153,274.5,257.622Z",
    transform: "translate(-214.755 -233.554)",
    fill: "#ccc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(0.119 27.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M274.883,255.58a3.831,3.831,0,0,1-1.4-.086l-36.15-21.065a1.627,1.627,0,0,0-1.634,0l-19.911,10.776a2.23,2.23,0,0,0-.014,3.627l35.56,20.53a1.627,1.627,0,0,0,1.634,0l21.691-12.6a.88.88,0,0,0,.225-1.177Z",
    transform: "translate(-214.849 -234.211)",
    fill: "#1b1f2d"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(21.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M232.1,213.809l.529,24.6a1.832,1.832,0,0,0,.909,1.585l35.524,20.96a1.878,1.878,0,0,0,2.646-1.795l.067-23.943a1.819,1.819,0,0,0-.888-1.567l-36.082-21.34A1.733,1.733,0,0,0,232.1,213.809Z",
    transform: "translate(-232.097 -212.035)",
    fill: "#31394c"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(21.803 0.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M232.1,213.6l-.071,25.055a1.831,1.831,0,0,0,.909,1.584l35.514,20.718a1.779,1.779,0,0,0,2.669-1.551l.067-23.947a1.817,1.817,0,0,0-.89-1.569l-36.207-21.409A1.313,1.313,0,0,0,232.1,213.6Z",
    transform: "translate(-232.032 -212.293)",
    fill: "#1b1f2d"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(23.152 1.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M233.176,213.474l-.075,24.542,36.272,20.971.073-24.293Z",
    transform: "translate(-233.101 -213.474)",
    fill: "#546fbf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(23.159 4.507)",
    opacity: 0.03,
    style: {
      mixBlendMode: "hard-light",
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M237.774,215.606l-4.615,2.133-.053,17.62,21.471-9.923Z",
    transform: "translate(-233.106 -215.606)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M257.211,224.694l-23.472,10.848,4.332,2.5,23.444-10.835Z",
    transform: "translate(-232.94 -213.226)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M262.833,227.987l-23.426,10.826,16.913,9.778,11.438-5.286.037-12.416Z",
    transform: "translate(-231.456 -212.363)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M259.376,248.937l4.263-1.97.013-4.514-8.609,3.979Z",
    transform: "translate(-227.359 -208.573)",
    fill: "#fff"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(0.242 27.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M274.691,256.243l-21.8,12.582a1.633,1.633,0,0,1-1.634,0l-35.5-20.638a1.63,1.63,0,0,1,0-2.822l19.964-11.522a1.633,1.633,0,0,1,1.634,0l37.331,21.706A.4.4,0,0,1,274.691,256.243Z",
    transform: "translate(-214.947 -233.622)",
    fill: "#31394c"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(14.49 44.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M241.882,253.462l-5.449,3.226a.441.441,0,0,1-.438,0l-9.539-5.508a.438.438,0,0,1,0-.757l5.221-2.954a.44.44,0,0,1,.439,0l9.768,5.808A.107.107,0,0,1,241.882,253.462Z",
    transform: "translate(-226.237 -247.41)",
    fill: "#cfdeff"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(10.702 29.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M231.886,236.3l1.222.714a.583.583,0,0,0,.536-.005l.608-.362c.149-.088.151-.228.005-.314l-1.224-.71a.583.583,0,0,0-.533.005l-.607.36C231.744,236.073,231.741,236.214,231.886,236.3Z",
    transform: "translate(-220.997 -235.559)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M233.595,237.3l1.235.722a.584.584,0,0,0,.54-.005l.611-.365a.169.169,0,0,0,0-.318l-1.239-.718a.583.583,0,0,0-.536.005l-.61.362C233.45,237.071,233.447,237.212,233.595,237.3Z",
    transform: "translate(-220.55 -235.299)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M235.323,238.31l1.251.732a.587.587,0,0,0,.545-.005l.612-.367a.171.171,0,0,0,0-.322l-1.253-.728a.591.591,0,0,0-.54.005l-.611.365C235.175,238.081,235.174,238.223,235.323,238.31Z",
    transform: "translate(-220.098 -235.036)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M237.072,239.335l1.267.741a.592.592,0,0,0,.548,0l.616-.371a.174.174,0,0,0,0-.326l-1.27-.737a.588.588,0,0,0-.544.005l-.613.368A.172.172,0,0,0,237.072,239.335Z",
    transform: "translate(-219.64 -234.769)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M238.844,240.371l1.282.751a.594.594,0,0,0,.553,0l.616-.375a.175.175,0,0,0-.005-.328L240,239.67a.591.591,0,0,0-.549,0l-.616.372A.173.173,0,0,0,238.844,240.371Z",
    transform: "translate(-219.176 -234.499)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M240.636,241.422l1.3.758a.591.591,0,0,0,.557,0l.618-.379a.177.177,0,0,0-.008-.332l-1.3-.755a.591.591,0,0,0-.553,0l-.617.375A.177.177,0,0,0,240.636,241.422Z",
    transform: "translate(-218.707 -234.226)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M242.452,242.485l1.315.769a.6.6,0,0,0,.562,0l.62-.381c.151-.093.146-.244-.011-.336l-1.316-.765a.6.6,0,0,0-.558,0l-.618.38A.178.178,0,0,0,242.452,242.485Z",
    transform: "translate(-218.232 -233.95)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M244.29,243.56l1.33.779a.6.6,0,0,0,.567,0l.622-.385c.151-.095.145-.246-.015-.339l-1.333-.775a.6.6,0,0,0-.562,0l-.621.382A.181.181,0,0,0,244.29,243.56Z",
    transform: "translate(-217.751 -233.67)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M246.151,244.651l1.348.787a.6.6,0,0,0,.57,0l.625-.389c.153-.095.145-.249-.018-.343l-1.349-.784a.6.6,0,0,0-.567,0l-.622.385A.183.183,0,0,0,246.151,244.651Z",
    transform: "translate(-217.265 -233.386)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M248.036,245.753l1.364.8a.608.608,0,0,0,.575,0l.625-.392c.154-.1.145-.251-.019-.346l-1.367-.8a.612.612,0,0,0-.57,0l-.625.391C247.866,245.5,247.874,245.659,248.036,245.753Z",
    transform: "translate(-216.771 -233.1)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M249.945,246.872l1.383.808a.612.612,0,0,0,.579,0l.627-.4c.154-.1.144-.254-.023-.351l-1.384-.8a.611.611,0,0,0-.575,0l-.627.394C249.772,246.619,249.781,246.776,249.945,246.872Z",
    transform: "translate(-216.272 -232.809)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M251.878,248l1.4.818a.608.608,0,0,0,.584,0l.63-.4c.154-.1.143-.257-.026-.355l-1.4-.815a.618.618,0,0,0-.581,0l-.628.4C251.7,247.748,251.712,247.905,251.878,248Z",
    transform: "translate(-215.766 -232.514)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M253.837,249.149l1.418.83a.613.613,0,0,0,.587,0l.632-.4c.154-.1.143-.259-.028-.358l-1.421-.825a.624.624,0,0,0-.586,0l-.63.4C253.657,248.892,253.668,249.051,253.837,249.149Z",
    transform: "translate(-215.254 -232.216)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M258.452,250.383l-1.439-.837a.62.62,0,0,0-.591,0l-.631.405c-.156.1-.143.26.028.36l1.437.84a.622.622,0,0,0,.593,0l.634-.408C258.639,250.646,258.625,250.483,258.452,250.383Z",
    transform: "translate(-214.735 -231.914)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M230.314,237.375l1.119.663a.729.729,0,0,0,.671-.006l1.105-.657c.187-.111.191-.288.008-.4l-1.123-.657a.727.727,0,0,0-.666.006l-1.1.652C230.137,237.091,230.133,237.268,230.314,237.375Z",
    transform: "translate(-221.416 -235.38)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M234.874,237.947l-1.137-.665a.727.727,0,0,0-.67.006l-1.108.658c-.187.112-.191.29-.008.4l1.133.67a.723.723,0,0,0,.674-.005l1.111-.664A.212.212,0,0,0,234.874,237.947Z",
    transform: "translate(-220.987 -235.128)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M236.549,238.928l-1.151-.673a.73.73,0,0,0-.675.005l-1.111.664a.215.215,0,0,0-.005.4l1.146.678a.729.729,0,0,0,.68-.005l1.114-.669A.214.214,0,0,0,236.549,238.928Z",
    transform: "translate(-220.554 -234.874)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M231.139,239.823l1.136.68a.726.726,0,0,0,.679-.005l1.118-.669a.216.216,0,0,0,.005-.4l-1.14-.675a.727.727,0,0,0-.674.005l-1.114.665C230.96,239.533,230.955,239.714,231.139,239.823Z",
    transform: "translate(-221.2 -234.744)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M228.673,238.345l2.085,1.248a.717.717,0,0,0,.673-.006l1.116-.663c.188-.112.192-.292.009-.4l-2.091-1.238a.719.719,0,0,0-.666.006l-1.109.656C228.5,238.06,228.493,238.237,228.673,238.345Z",
    transform: "translate(-221.845 -235.127)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M235.754,240.419l-1.153-.683a.726.726,0,0,0-.679.005l-1.118.669c-.191.115-.193.3-.006.408l1.15.689a.73.73,0,0,0,.683-.005l1.122-.675A.218.218,0,0,0,235.754,240.419Z",
    transform: "translate(-220.766 -234.486)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M237.451,241.424l-1.166-.692a.736.736,0,0,0-.684,0l-1.122.676a.22.22,0,0,0,0,.411l1.164.7a.733.733,0,0,0,.688,0l1.124-.681A.219.219,0,0,0,237.451,241.424Z",
    transform: "translate(-220.327 -234.225)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M239.169,242.439l-1.181-.7a.736.736,0,0,0-.689,0l-1.124.683a.222.222,0,0,0,0,.415l1.177.7a.736.736,0,0,0,.693,0l1.128-.688A.223.223,0,0,0,239.169,242.439Z",
    transform: "translate(-219.883 -233.962)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M240.9,243.469l-1.194-.708a.738.738,0,0,0-.694,0l-1.129.688a.224.224,0,0,0,0,.419l1.191.714a.741.741,0,0,0,.7,0l1.131-.694A.225.225,0,0,0,240.9,243.469Z",
    transform: "translate(-219.434 -233.695)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M242.664,244.509l-1.209-.717a.745.745,0,0,0-.7,0l-1.132.694a.228.228,0,0,0,.005.424l1.206.722a.745.745,0,0,0,.7,0l1.135-.7A.228.228,0,0,0,242.664,244.509Z",
    transform: "translate(-218.979 -233.424)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M244.443,245.564l-1.223-.726a.751.751,0,0,0-.705,0l-1.135.7a.231.231,0,0,0,.008.429l1.22.729a.747.747,0,0,0,.71,0l1.138-.705A.23.23,0,0,0,244.443,245.564Z",
    transform: "translate(-218.519 -233.151)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M246.245,246.63l-1.239-.733a.75.75,0,0,0-.71,0l-1.138.707a.233.233,0,0,0,.013.433l1.235.74a.754.754,0,0,0,.714,0l1.142-.713C246.454,246.944,246.446,246.75,246.245,246.63Z",
    transform: "translate(-218.053 -232.874)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M244.971,248.119l1.252.748a.75.75,0,0,0,.719,0l1.146-.718c.193-.121.184-.318-.02-.439l-1.253-.743a.759.759,0,0,0-.717,0l-1.141.713A.236.236,0,0,0,244.971,248.119Z",
    transform: "translate(-217.582 -232.594)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M249.938,249.246c.193-.122.183-.321-.024-.444l-1.27-.751a.753.753,0,0,0-.721,0l-1.146.719c-.193.122-.186.319.019.443l1.267.757a.759.759,0,0,0,.726,0Z",
    transform: "translate(-217.104 -232.311)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M251.81,250.357c.194-.124.183-.324-.027-.448l-1.285-.761a.762.762,0,0,0-.727,0l-1.15.727c-.194.122-.184.323.023.447l1.282.767a.759.759,0,0,0,.731,0Z",
    transform: "translate(-216.621 -232.023)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M250.515,251.443l1.3.776a.761.761,0,0,0,.737,0l1.156-.74c.194-.125.179-.327-.032-.453l-1.3-.771a.768.768,0,0,0-.732,0l-1.153.733C250.294,251.114,250.306,251.317,250.515,251.443Z",
    transform: "translate(-216.132 -231.733)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M229.917,240.661c-.191.115-.2.3-.013.408l1.137.688a.725.725,0,0,0,.68,0l1.124-.675c.191-.114.194-.3.009-.406l-1.14-.684a.725.725,0,0,0-.676.005Z",
    transform: "translate(-221.523 -234.42)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M227.025,239.322l2.637,1.6a.719.719,0,0,0,.675-.005l1.122-.669c.191-.112.194-.293.011-.4l-2.645-1.586a.717.717,0,0,0-.669.006l-1.116.66C226.852,239.034,226.845,239.213,227.025,239.322Z",
    transform: "translate(-222.276 -234.873)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M231.571,241.663c-.191.115-.2.3-.009.411l1.15.7a.728.728,0,0,0,.685,0l1.128-.681a.22.22,0,0,0,.005-.411l-1.152-.692a.728.728,0,0,0-.681.005Z",
    transform: "translate(-221.09 -234.16)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M233.24,243.092l1.164.705a.728.728,0,0,0,.69,0l1.132-.686a.222.222,0,0,0,0-.415l-1.167-.7a.731.731,0,0,0-.686,0l-1.128.683A.222.222,0,0,0,233.24,243.092Z",
    transform: "translate(-220.651 -233.896)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M234.937,244.122l1.177.713a.74.74,0,0,0,.7,0l1.135-.693a.226.226,0,0,0,0-.422l-1.18-.707a.734.734,0,0,0-.692,0l-1.132.688A.225.225,0,0,0,234.937,244.122Z",
    transform: "translate(-220.207 -233.629)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M236.655,245.164l1.193.722a.737.737,0,0,0,.7,0l1.14-.7a.228.228,0,0,0,0-.425l-1.2-.716a.737.737,0,0,0-.7,0l-1.136.693A.228.228,0,0,0,236.655,245.164Z",
    transform: "translate(-219.757 -233.359)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M238.395,246.22l1.206.729a.737.737,0,0,0,.705,0l1.143-.705a.231.231,0,0,0-.008-.429l-1.209-.726a.747.747,0,0,0-.7,0l-1.14.7A.23.23,0,0,0,238.395,246.22Z",
    transform: "translate(-219.303 -233.085)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M240.154,247.287l1.222.74a.749.749,0,0,0,.712,0l1.146-.712a.234.234,0,0,0-.011-.434L242,246.147a.743.743,0,0,0-.707,0l-1.143.705A.233.233,0,0,0,240.154,247.287Z",
    transform: "translate(-218.842 -232.809)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M241.936,248.369l1.237.748a.752.752,0,0,0,.717,0l1.15-.718a.236.236,0,0,0-.014-.438l-1.239-.743a.752.752,0,0,0-.713,0l-1.147.713A.237.237,0,0,0,241.936,248.369Z",
    transform: "translate(-218.376 -232.528)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M243.739,249.462l1.251.758a.758.758,0,0,0,.723,0l1.153-.724a.24.24,0,0,0-.018-.444l-1.254-.752a.755.755,0,0,0-.718,0l-1.15.719A.238.238,0,0,0,243.739,249.462Z",
    transform: "translate(-217.904 -232.245)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M245.565,250.571l1.267.767a.758.758,0,0,0,.728,0l1.156-.732c.2-.124.186-.324-.021-.448l-1.27-.761a.754.754,0,0,0-.723,0l-1.153.726C245.353,250.246,245.36,250.446,245.565,250.571Z",
    transform: "translate(-217.427 -231.958)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M249.43,252.471l1.16-.738c.2-.125.184-.328-.025-.453l-1.286-.771a.763.763,0,0,0-.729,0l-1.156.732c-.2.125-.187.327.02.453l1.282.776A.76.76,0,0,0,249.43,252.471Z",
    transform: "translate(-216.944 -231.667)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M254.244,253.484l-3.065-1.837a.763.763,0,0,0-.734,0l-1.161.74c-.2.125-.186.331.024.457l3.058,1.851a.763.763,0,0,0,.745,0l1.166-.751C254.471,253.819,254.457,253.613,254.244,253.484Z",
    transform: "translate(-216.448 -231.37)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M229.1,242.594l1.141.7a.722.722,0,0,0,.684,0l1.133-.681a.221.221,0,0,0,.009-.413l-1.142-.693a.722.722,0,0,0-.68,0l-1.131.676C228.919,242.3,228.913,242.481,229.1,242.594Z",
    transform: "translate(-221.735 -234.024)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M226.766,241.011l-1.333-.818a.467.467,0,0,0-.439,0l-1.66.98c-.126.074-.134.194-.015.266l1.326.825a.47.47,0,0,0,.444,0l1.663-.987C226.88,241.2,226.885,241.084,226.766,241.011Z",
    transform: "translate(-223.235 -234.359)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M228.407,242.016l-1.348-.827a.473.473,0,0,0-.444,0l-1.665.989c-.126.074-.133.2-.014.27l1.344.834a.468.468,0,0,0,.447,0l1.668-1C228.522,242.211,228.527,242.09,228.407,242.016Z",
    transform: "translate(-222.812 -234.098)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M230.067,243.035,228.7,242.2a.471.471,0,0,0-.447,0l-1.67,1c-.127.076-.132.2-.011.273l1.359.844a.473.473,0,0,0,.449,0l1.675-1.006C230.184,243.232,230.188,243.11,230.067,243.035Z",
    transform: "translate(-222.383 -233.834)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M232.232,244.363l-1.865-1.145a.475.475,0,0,0-.451,0l-1.675,1.006c-.127.077-.132.2-.01.276l1.86,1.156a.479.479,0,0,0,.454,0l1.68-1.017A.149.149,0,0,0,232.232,244.363Z",
    transform: "translate(-221.949 -233.567)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M243.235,251.112l-2.014-1.235a.49.49,0,0,0-.472,0l-1.707,1.065a.158.158,0,0,0,0,.293l2.008,1.248a.493.493,0,0,0,.477,0l1.712-1.076A.16.16,0,0,0,243.235,251.112Z",
    transform: "translate(-219.12 -231.824)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M244.971,252.179l-1.487-.914a.49.49,0,0,0-.477,0l-1.715,1.076a.163.163,0,0,0,.006.3l1.483.92a.491.491,0,0,0,.481,0l1.719-1.085A.161.161,0,0,0,244.971,252.179Z",
    transform: "translate(-218.53 -231.461)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M245.751,253.883l-1.5-.93a.491.491,0,0,0-.48,0l-.625.394a.164.164,0,0,0,.008.3l1.5.933a.491.491,0,0,0,.485,0l.626-.4C245.894,254.1,245.889,253.968,245.751,253.883Z",
    transform: "translate(-218.045 -231.019)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M249.546,256.225,248,255.273a.5.5,0,0,0-.488,0l-.628.4a.168.168,0,0,0,.011.308l1.542.958a.5.5,0,0,0,.491,0l.631-.405C249.693,256.45,249.686,256.311,249.546,256.225Z",
    transform: "translate(-217.064 -230.412)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M247.637,255.047l-1.523-.94a.491.491,0,0,0-.485,0l-.626.4a.166.166,0,0,0,.01.305l1.521.945a.5.5,0,0,0,.488,0l.628-.4A.167.167,0,0,0,247.637,255.047Z",
    transform: "translate(-217.558 -230.717)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M245.982,254.189l1.523.94a.5.5,0,0,0,.488,0l.626-.4a.167.167,0,0,0-.014-.305l-1.526-.935a.492.492,0,0,0-.485,0l-.625.4A.166.166,0,0,0,245.982,254.189Z",
    transform: "translate(-217.304 -230.878)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M242.619,250.739l-10.189-6.256a.483.483,0,0,0-.454,0l-1.681,1.017a.151.151,0,0,0-.008.28l10.158,6.311a.487.487,0,0,0,.471,0l1.707-1.063A.158.158,0,0,0,242.619,250.739Z",
    transform: "translate(-221.412 -233.236)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M225.367,240.3l3.619,2.217a.719.719,0,0,0,.679,0l1.131-.675c.189-.115.2-.3.011-.409l-3.629-2.2a.713.713,0,0,0-.669.005l-1.123.664C225.2,240.013,225.188,240.193,225.367,240.3Z",
    transform: "translate(-222.71 -234.618)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M230.76,243.614l1.153.707a.722.722,0,0,0,.689,0l1.137-.688a.223.223,0,0,0,.006-.416l-1.156-.7a.725.725,0,0,0-.685,0l-1.135.683A.223.223,0,0,0,230.76,243.614Z",
    transform: "translate(-221.3 -233.76)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M232.444,244.648l1.166.716a.731.731,0,0,0,.7,0l1.14-.693a.226.226,0,0,0,0-.422l-1.17-.71a.731.731,0,0,0-.69,0l-1.138.689A.226.226,0,0,0,232.444,244.648Z",
    transform: "translate(-220.859 -233.492)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M234.146,245.693l1.181.724a.735.735,0,0,0,.7,0l1.145-.7a.229.229,0,0,0,0-.425l-1.184-.718a.731.731,0,0,0-.7,0l-1.141.694A.229.229,0,0,0,234.146,245.693Z",
    transform: "translate(-220.414 -233.221)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M235.87,246.751l1.2.733a.738.738,0,0,0,.7,0l1.147-.705a.231.231,0,0,0,0-.43l-1.2-.728a.741.741,0,0,0-.7,0l-1.145.7A.231.231,0,0,0,235.87,246.751Z",
    transform: "translate(-219.963 -232.946)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M237.614,247.823l1.21.741a.74.74,0,0,0,.711,0l1.151-.712a.235.235,0,0,0-.006-.435l-1.213-.736a.74.74,0,0,0-.705,0l-1.148.707A.234.234,0,0,0,237.614,247.823Z",
    transform: "translate(-219.507 -232.669)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M239.381,248.906l1.225.751a.746.746,0,0,0,.716,0l1.153-.719a.237.237,0,0,0-.009-.439l-1.228-.746a.749.749,0,0,0-.712,0l-1.151.714A.236.236,0,0,0,239.381,248.906Z",
    transform: "translate(-219.045 -232.388)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M241.169,250l1.241.76a.75.75,0,0,0,.721,0l1.158-.727a.24.24,0,0,0-.013-.444l-1.244-.753a.749.749,0,0,0-.717,0l-1.155.719A.24.24,0,0,0,241.169,250Z",
    transform: "translate(-218.577 -232.104)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M242.978,251.115l1.256.77a.762.762,0,0,0,.727,0l1.161-.733c.2-.124.189-.324-.016-.449l-1.258-.764a.754.754,0,0,0-.723,0l-1.157.727A.242.242,0,0,0,242.978,251.115Z",
    transform: "translate(-218.104 -231.816)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M247.96,251.828l-1.275-.774a.757.757,0,0,0-.728,0l-1.161.733a.247.247,0,0,0,.015.454l1.271.779a.761.761,0,0,0,.733,0l1.165-.74C248.175,252.157,248.166,251.954,247.96,251.828Z",
    transform: "translate(-217.625 -231.524)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M252.819,254.775l-4.273-2.592a.767.767,0,0,0-.733,0l-1.165.741a.248.248,0,0,0,.018.457l4.263,2.612a.768.768,0,0,0,.746.005l1.172-.756C253.043,255.112,253.032,254.9,252.819,254.775Z",
    transform: "translate(-217.139 -231.229)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M255.59,252.164l-1.316-.781a.774.774,0,0,0-.738,0l-1.156.74c-.2.126-.183.331.029.457l1.315.787a.774.774,0,0,0,.743,0l1.158-.745C255.821,252.5,255.8,252.291,255.59,252.164Z",
    transform: "translate(-215.637 -231.439)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M238.243,239.92l-1.162-.68a.731.731,0,0,0-.681.005l-1.114.669a.217.217,0,0,0,0,.406l1.161.686a.736.736,0,0,0,.684-.005l1.118-.674A.218.218,0,0,0,238.243,239.92Z",
    transform: "translate(-220.116 -234.616)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M239.958,240.924l-1.176-.689a.738.738,0,0,0-.687.005l-1.117.675a.219.219,0,0,0,0,.41l1.174.694a.738.738,0,0,0,.69,0l1.119-.68A.219.219,0,0,0,239.958,240.924Z",
    transform: "translate(-219.672 -234.356)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M241.693,241.94l-1.19-.7a.741.741,0,0,0-.692.005l-1.119.68a.222.222,0,0,0,0,.415l1.188.7a.747.747,0,0,0,.7,0l1.123-.687A.222.222,0,0,0,241.693,241.94Z",
    transform: "translate(-219.223 -234.092)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M243.45,242.968l-1.205-.705a.738.738,0,0,0-.7,0l-1.124.687a.224.224,0,0,0,.006.419l1.2.712a.748.748,0,0,0,.7,0l1.127-.692A.225.225,0,0,0,243.45,242.968Z",
    transform: "translate(-218.769 -233.825)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M245.228,244.008l-1.219-.714a.75.75,0,0,0-.7,0l-1.128.694a.226.226,0,0,0,.01.423l1.218.719a.744.744,0,0,0,.705,0l1.129-.7C245.432,244.315,245.426,244.124,245.228,244.008Z",
    transform: "translate(-218.309 -233.555)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M247.027,245.061l-1.234-.723a.753.753,0,0,0-.707,0l-1.131.7a.23.23,0,0,0,.013.428l1.233.728a.75.75,0,0,0,.71,0l1.133-.705C247.236,245.37,247.227,245.178,247.027,245.061Z",
    transform: "translate(-217.844 -233.282)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M248.847,246.127,247.6,245.4a.756.756,0,0,0-.712,0l-1.133.707c-.193.119-.186.312.015.432l1.247.737a.759.759,0,0,0,.717,0l1.137-.712C249.061,246.44,249.051,246.246,248.847,246.127Z",
    transform: "translate(-217.373 -233.005)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M250.691,247.205l-1.266-.741a.763.763,0,0,0-.717,0l-1.138.713c-.192.12-.183.315.021.437l1.262.746a.755.755,0,0,0,.722,0l1.14-.718C250.907,247.522,250.9,247.326,250.691,247.205Z",
    transform: "translate(-216.896 -232.725)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M250.714,249.465a.768.768,0,0,0,.728,0l1.143-.724c.193-.122.18-.321-.028-.443l-1.281-.75a.764.764,0,0,0-.723,0l-1.141.719c-.193.122-.183.319.024.442Z",
    transform: "translate(-216.414 -232.442)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M254.447,249.4l-1.3-.758a.764.764,0,0,0-.728,0l-1.143.726c-.194.122-.183.323.027.447l1.294.765a.77.77,0,0,0,.734,0l1.146-.731C254.671,249.728,254.657,249.527,254.447,249.4Z",
    transform: "translate(-215.925 -232.155)",
    fill: "#cfdeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M257.732,251.328l-2.761-1.618a.493.493,0,0,0-.468,0l-1.4.9c-.124.079-.115.208.02.288l2.755,1.63a.5.5,0,0,0,.473,0l1.407-.907C257.879,251.539,257.869,251.408,257.732,251.328Z",
    transform: "translate(-215.434 -231.868)",
    fill: "#cfdeff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M260.47,327.443c-3.656,1.08-7.048,3.087-10.773,4.018-3.267,1.065-6.586,1.853-9.906,2.72a17.242,17.242,0,0,0-5.984,2.559c-.8.589-.659,1.829-.581,2.7.131,1.455,2.071,2.165,3.231,2.56a10.734,10.734,0,0,0,5.033.525,15.922,15.922,0,0,0,6.031-2.7c1.758-1.1,3.547-2.143,5.4-3.067,1.807-.9,3.716-1.514,5.549-2.351,1.748-.8,3.084-2.024,3.257-4.018a6.519,6.519,0,0,0,.006-1.552,2.245,2.245,0,0,0-.637-1.309.519.519,0,0,0-.273-.153.593.593,0,0,0-.242.035Z",
    transform: "translate(-138.97 -153.322)",
    fill: "#31394c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M256.312,325.121a13.355,13.355,0,0,0-1.755.018c-1.43.1-2.846.342-4.272.479a23.231,23.231,0,0,1-4.52-.13c-.472-.045-.945-.083-1.42-.092a11.294,11.294,0,0,0-9.537,5.683c-.011-.006-.021-.016-.034-.01-1.57.66-.933,2.8-1.066,4.111a16.116,16.116,0,0,0-.462,2.841,2.362,2.362,0,0,0,1.2,1.7,9.9,9.9,0,0,0,8.131,1.442,26.777,26.777,0,0,0,5.775-2.926,59.277,59.277,0,0,1,7.25-3.687,19.588,19.588,0,0,0,3.865-1.71c1.524-1.027,2.709-2.8,1.9-4.643C260.4,326,258.441,325.25,256.312,325.121Z",
    transform: "translate(-138.951 -153.917)",
    fill: "#546fbf"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M251.936,327.836a16.827,16.827,0,0,0-3.744-2.261,24.646,24.646,0,0,1-4.191-.148c-.471-.044-.943-.082-1.417-.092a6.853,6.853,0,0,0-1.683,1.059.339.339,0,0,0-.106.184l-.146.177a3.255,3.255,0,0,0-.577,1.044,2.709,2.709,0,0,0,.5,2.349,6.313,6.313,0,0,0,1.617,1.868,2.887,2.887,0,0,0,1.06.5,1.363,1.363,0,0,0,1.092-.12.229.229,0,0,0,.064-.16,16.228,16.228,0,0,1,5.762-1.62c.757-.1,2.01-.194,2.525-.849C253.224,329.087,252.451,328.246,251.936,327.836Z",
    transform: "translate(-137.187 -153.855)",
    fill: "#2b3d89"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M246.194,318.308c-3.656,1.082-7.048,3.088-10.773,4.019-3.267,1.064-6.586,1.851-9.906,2.72a17.211,17.211,0,0,0-5.986,2.559c-.8.589-.657,1.827-.579,2.7.131,1.456,2.071,2.168,3.231,2.561a10.715,10.715,0,0,0,5.033.525,15.934,15.934,0,0,0,6.032-2.7c1.757-1.1,3.546-2.144,5.4-3.068,1.807-.9,3.716-1.513,5.549-2.351,1.749-.8,3.084-2.023,3.257-4.017a6.517,6.517,0,0,0,.006-1.552,2.245,2.245,0,0,0-.637-1.31.524.524,0,0,0-.271-.153.625.625,0,0,0-.245.037Z",
    transform: "translate(-142.71 -155.715)",
    fill: "#31394c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M242.038,315.986a13.852,13.852,0,0,0-1.757.018c-1.43.1-2.846.343-4.273.481a23.131,23.131,0,0,1-4.519-.13c-.472-.045-.945-.083-1.42-.092a11.3,11.3,0,0,0-9.537,5.681c-.011-.005-.021-.016-.034-.01-1.57.66-.933,2.8-1.066,4.113a16.081,16.081,0,0,0-.463,2.841,2.365,2.365,0,0,0,1.205,1.7,9.894,9.894,0,0,0,8.131,1.442,26.665,26.665,0,0,0,5.775-2.927,59.275,59.275,0,0,1,7.25-3.686,19.659,19.659,0,0,0,3.865-1.71c1.524-1.027,2.708-2.8,1.9-4.644C246.122,316.872,244.165,316.115,242.038,315.986Z",
    transform: "translate(-142.691 -156.31)",
    fill: "#546fbf"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M237.68,320.865c.531-.679-.24-1.519-.756-1.928a16.228,16.228,0,0,0-4.243-2.461c-.916-.018-1.827-.092-2.764-.183-.472-.045-.945-.083-1.42-.092-.125,0-.25.02-.375.024a6.639,6.639,0,0,0-2.234,1.27.329.329,0,0,0-.107.184c-.052.063-.1.125-.145.177a3.205,3.205,0,0,0-.577,1.044,2.709,2.709,0,0,0,.5,2.349,6.33,6.33,0,0,0,1.617,1.868,2.906,2.906,0,0,0,1.06.5,1.354,1.354,0,0,0,1.09-.121.223.223,0,0,0,.066-.16,16.274,16.274,0,0,1,5.762-1.62C235.912,321.615,237.165,321.521,237.68,320.865Z",
    transform: "translate(-141.12 -156.248)",
    fill: "#2b3d89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(18.613 178.002)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M180.88,334.636a2.746,2.746,0,0,1,2.311-.081l21.538,11.131,18.929-13.926c.037-.026.076-.05.115-.074.517-.3,1.721-1.352,2.408-1.158.864.242.819,1.8.4,2.307l-12.734,15.54,31.341,4.456c.191.035.77-.81.924-.742.462.208.328,1.446.255,1.807a.933.933,0,0,1-.5.607,2.612,2.612,0,0,1-1.42.289l-32.242-.57,3.328,14.062-.006,1.023a.821.821,0,0,1-.5.822,2.252,2.252,0,0,1-.694.247,2.162,2.162,0,0,1-2.183-.651l-10.039-14.572-26.2,6.837a2.628,2.628,0,0,1-2.11-.278c-.567-.4-.771-1.8-.14-2.159.042-.025.612-.1.659-.127l23.186-9.568-16.768-13.885c-.481-.358-.75-1.8-.251-2.178.045-.033.343.872.394.843",
    transform: "translate(-173.272 -330.503)",
    fill: "gray"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(86.709 192.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M230.582,342.566c1.868-1.079,3.376-.2,3.382,1.927a7.386,7.386,0,0,1-3.361,5.821c-1.855,1.073-3.364.212-3.371-1.935a7.4,7.4,0,0,1,3.349-5.814",
    transform: "translate(-227.233 -342.103)",
    fill: "#1b1f2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M231.354,352.464l-3.245-1.9,4.649-8.272,3.366,1.961Z",
    transform: "translate(-227.003 -342.055)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(3.415 1.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M233.288,344.144c1.868-1.079,3.377-.206,3.382,1.927a7.387,7.387,0,0,1-3.361,5.823c-1.855,1.07-3.364.211-3.371-1.936a7.405,7.405,0,0,1,3.349-5.814",
    transform: "translate(-229.939 -343.681)",
    fill: "#1b1f2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(3.605 2.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M233.25,344.313c1.762-1.018,3.185-.194,3.192,1.817a6.971,6.971,0,0,1-3.171,5.493c-1.75,1.01-3.174.2-3.18-1.826a6.983,6.983,0,0,1,3.16-5.484",
    transform: "translate(-230.09 -343.876)",
    fill: "#31394c"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(54.633 208.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M205.164,355.375c1.868-1.079,3.376-.206,3.382,1.928a7.383,7.383,0,0,1-3.361,5.82c-1.856,1.073-3.364.212-3.371-1.933a7.4,7.4,0,0,1,3.349-5.815",
    transform: "translate(-201.815 -354.912)",
    fill: "#1b1f2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M205.936,365.272l-3.245-1.9,4.649-8.272,3.366,1.961Z",
    transform: "translate(-201.586 -354.863)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(3.415 1.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M207.87,356.952c1.868-1.078,3.377-.2,3.382,1.93a7.382,7.382,0,0,1-3.361,5.82c-1.855,1.073-3.364.212-3.371-1.935a7.406,7.406,0,0,1,3.349-5.815",
    transform: "translate(-204.521 -356.49)",
    fill: "#1b1f2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(3.605 2.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M207.832,357.12c1.762-1.016,3.185-.193,3.192,1.82a6.97,6.97,0,0,1-3.171,5.491c-1.75,1.011-3.174.2-3.18-1.825a6.984,6.984,0,0,1,3.16-5.486",
    transform: "translate(-204.672 -356.685)",
    fill: "#31394c"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(15.256 200.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M173.961,348.745c1.869-1.078,3.377-.206,3.383,1.928a7.383,7.383,0,0,1-3.361,5.82c-1.858,1.073-3.366.212-3.372-1.933a7.4,7.4,0,0,1,3.349-5.815",
    transform: "translate(-170.612 -348.283)",
    fill: "#1b1f2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M174.733,358.642l-3.245-1.9,4.649-8.272,3.366,1.961Z",
    transform: "translate(-170.382 -348.234)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(3.415 1.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M176.667,350.323c1.869-1.079,3.377-.2,3.383,1.928a7.385,7.385,0,0,1-3.361,5.82c-1.856,1.073-3.366.212-3.372-1.935a7.407,7.407,0,0,1,3.349-5.814",
    transform: "translate(-173.318 -349.86)",
    fill: "#1b1f2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(3.607 2.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M176.629,350.49c1.763-1.016,3.186-.193,3.191,1.82a6.967,6.967,0,0,1-3.17,5.491c-1.752,1.011-3.175.2-3.18-1.825a6.983,6.983,0,0,1,3.159-5.486",
    transform: "translate(-173.47 -350.055)",
    fill: "#31394c"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(21.341 175.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M178.783,328.906c1.868-1.079,3.377-.206,3.383,1.927a7.39,7.39,0,0,1-3.362,5.821c-1.856,1.071-3.364.212-3.371-1.935a7.4,7.4,0,0,1,3.349-5.814",
    transform: "translate(-175.434 -328.443)",
    fill: "#1b1f2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M179.555,338.8l-3.245-1.9,4.649-8.272,3.366,1.961Z",
    transform: "translate(-175.204 -328.394)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(3.415 1.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M181.489,330.484c1.868-1.08,3.377-.206,3.383,1.927a7.388,7.388,0,0,1-3.362,5.82c-1.856,1.073-3.364.212-3.371-1.933a7.4,7.4,0,0,1,3.349-5.814",
    transform: "translate(-178.14 -330.021)",
    fill: "#1b1f2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    transform: "translate(3.605 2.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M181.451,330.652c1.762-1.017,3.185-.194,3.192,1.819a6.97,6.97,0,0,1-3.171,5.491c-1.75,1.012-3.174.2-3.18-1.825a6.987,6.987,0,0,1,3.16-5.484",
    transform: "translate(-178.291 -330.215)",
    fill: "#31394c"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(66.594 171.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M214.642,325.563c1.868-1.079,3.377-.2,3.382,1.927a7.386,7.386,0,0,1-3.361,5.821c-1.856,1.073-3.364.212-3.371-1.935a7.4,7.4,0,0,1,3.349-5.814",
    transform: "translate(-211.293 -325.1)",
    fill: "#1b1f2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M215.414,335.461l-3.245-1.9,4.649-8.272,3.366,1.961Z",
    transform: "translate(-211.064 -325.052)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(3.415 1.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M217.348,327.141c1.868-1.079,3.377-.206,3.382,1.927a7.385,7.385,0,0,1-3.361,5.821c-1.855,1.071-3.364.212-3.371-1.935a7.4,7.4,0,0,1,3.349-5.814",
    transform: "translate(-213.999 -326.678)",
    fill: "#1b1f2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(3.605 2.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M217.31,327.31c1.762-1.018,3.185-.194,3.191,1.817a6.974,6.974,0,0,1-3.171,5.493c-1.75,1.011-3.174.2-3.18-1.826a6.982,6.982,0,0,1,3.16-5.484",
    transform: "translate(-214.15 -326.873)",
    fill: "#31394c"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(18.613 171.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M180.88,329.232a2.755,2.755,0,0,1,2.311-.081l21.538,9.028,18.929-11.822c.037-.027.076-.05.115-.074.517-.3,1.721-1.353,2.408-1.158.864.241.819,1.8.4,2.3l-12.734,13.437,31.341,6.56c.191.035.77-.81.924-.741.462.207.328,1.446.255,1.807a.932.932,0,0,1-.5.6,2.589,2.589,0,0,1-1.42.29l-32.242-2.673,3.328,16.163-.006,1.025a.82.82,0,0,1-.5.821,2.25,2.25,0,0,1-.694.247,2.162,2.162,0,0,1-2.183-.65l-10.039-16.677-26.2,8.941a2.633,2.633,0,0,1-2.11-.276c-.567-.4-.771-1.8-.14-2.162.042-.023.612-.1.659-.125l23.186-11.672-16.768-11.782c-.481-.361-.75-1.8-.251-2.178.045-.033.343.871.394.842",
    transform: "translate(-173.272 -325.1)",
    fill: "#a6bfff"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(18.756 170.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M180.851,328.087a2.755,2.755,0,0,1,2.311-.082l21.538,6.543,18.929-9.26c.037-.025.076-.049.115-.073a2.768,2.768,0,0,1,2.005-.2c.863.241,1.222.846.8,1.345l-12.734,10.874,31.341,9.081c.762.141,1.277.584,1.179,1.065a.931.931,0,0,1-.5.606,2.6,2.6,0,0,1-1.42.29l-32.242-5.2,3.322,19.752a.822.822,0,0,1-.5.822,2.253,2.253,0,0,1-.694.247,2.162,2.162,0,0,1-2.183-.651l-10.039-19.239-26.2,11.6a2.633,2.633,0,0,1-2.11-.278c-.567-.4-.5-.986.134-1.35.042-.023.086-.047.133-.069l23.438-15.2-16.768-9.3a.708.708,0,0,1,0-1.242,1.373,1.373,0,0,1,.143-.092",
    transform: "translate(-173.386 -324.914)",
    fill: "#cfdeff"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M205.928,327.544v10.067h0a2.875,2.875,0,0,1-1.69,2.328,8.811,8.811,0,0,1-8.024,0,2.836,2.836,0,0,1-1.663-2.328v-9.852Z",
    transform: "translate(-149.085 -153.277)",
    fill: "#a6bfff"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(45.466 171.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M196.222,326.068a8.9,8.9,0,0,1,8.061,0c2.216,1.287,2.186,3.371-.045,4.659a8.818,8.818,0,0,1-8.024,0c-2.215-1.288-2.222-3.372.008-4.659",
    transform: "translate(-194.551 -325.103)",
    fill: "#cfdeff"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M205.356,320.315v9.227h0a2.641,2.641,0,0,1-1.548,2.135,8.078,8.078,0,0,1-7.356,0,2.6,2.6,0,0,1-1.524-2.135v-9.031Z",
    transform: "translate(-148.987 -155.171)",
    fill: "#91aaf2"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(45.94 162.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M196.458,318.962a8.159,8.159,0,0,1,7.391,0c2.031,1.181,2,3.092-.042,4.27a8.078,8.078,0,0,1-7.356,0c-2.032-1.179-2.038-3.089.006-4.27",
    transform: "translate(-194.926 -318.077)",
    fill: "#a6bfff"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M183.294,308.814c9.538,14.014,44.7-18.185,44.7-18.185-2.429,11.062,3.7,18.3,1.608,41a1.921,1.921,0,0,0,.368,1.331,7.592,7.592,0,0,0,4.39,3.054c3.738.639,5.95-.679,6.912-1.487a1.807,1.807,0,0,0,.635-1.214c.421-4.249,2.78-28.255,3.123-36.926.265-6.673,1.348-20.489-9.5-22.81-7.842-1.678-33.821,8.5-33.821,8.5S172.765,293.341,183.294,308.814Z",
    transform: "translate(-152.638 -167.464)",
    fill: "#1b1f2d"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(5.53 115.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M254.4,302.41,221.73,283.545c-5.179-2.991-13.471-3.108-18.86-.268L167.357,302c-5.771,3.045-5.953,8.268-.42,11.462l35.994,20.781c5.54,3.2,14.557,3.077,19.786-.28l32.2-20.633c4.886-3.13,4.655-7.933-.515-10.917",
    transform: "translate(-162.905 -281.222)",
    fill: "#2b3d89"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M165.648,302.578c.31-.2.639-.395.991-.58l35.513-18.72c5.389-2.841,13.681-2.723,18.86.268l32.673,18.865a9.06,9.06,0,0,1,3.147,2.834c-2.925,3.42-9.516,4.92-13.189,6.43-6.627,2.722-12.461,6.941-18.379,10.9-2.925,1.959-5.808,4.192-9.277,4.995a20.171,20.171,0,0,1-11.1-.55c-5.991-2.085-10.642-7-16.023-10.209a60.6,60.6,0,0,0-10.306-4.891A92.181,92.181,0,0,1,170,308.189c-1.774-.859-3.623-2.193-4.182-4.185A4.744,4.744,0,0,1,165.648,302.578Z",
    transform: "translate(-156.657 -165.411)",
    fill: "#354d9b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M216.115,216.233c.028-.766-1.752-4.11-2.579-5.623-.733-4.948-1.543-8.944-1.543-8.944-5.592-4.746-18.9,15.829-18.9,15.829l-1.444,18.912c7.174,6.6,13.831,2.863,13.831,2.863.146-8.579,5.752-6.924,8.29-10.66,1.087-1.6,1.084-5.9.668-10.611C215.23,217.468,216.1,216.771,216.115,216.233Z",
    transform: "translate(-149.847 -186.438)",
    fill: "#f2c599"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M194.585,235.217c6.885,2.085,10.763-1.054,12.694-6.815,0,0,.456-.683-2.183-1.476s-3.68-8.937-.967-8.3,2.587,4.354,3.743,4.668,1.8-.776.938-3.368,4.134-3.188,2.534-6.182a5.473,5.473,0,0,1,2.638-7.8c3.132-1.471,1.114-13.528-1.3-12.828s-2.884,3.111-4.312.339-2.564-4.875-4.71-3.643-.785,2.847-3.306,1.822-3.019-.308-3.889,1.482.591,2.841-2.306,3.092-1.951,2.8-4.7,5.209-7.676,3.561-7.2,12.04S188.355,233.33,194.585,235.217Z",
    transform: "translate(-152.312 -189.452)",
    fill: "#31394c"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M213.807,220.1c-.069-.326-.387-.317-.655-.332-.4-.02-.8-.033-1.193-.054a20.479,20.479,0,0,1-3.464-.406,15.827,15.827,0,0,1-2.455-.786c-.392-.159-.78-.332-1.164-.512a5.265,5.265,0,0,0-1.085-.464.447.447,0,0,0-.529.376c-.11.5.548.731.892.917a17.057,17.057,0,0,0,1.6.765,16.8,16.8,0,0,0,6.63,1.386,3.2,3.2,0,0,0,1.025-.193.588.588,0,0,0,.416-.55A.706.706,0,0,0,213.807,220.1Z",
    transform: "translate(-146.806 -182.096)",
    fill: "#546fbf"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M215.4,219.8a1.346,1.346,0,0,0-.806-1.191,2.072,2.072,0,0,0-.593-.056,10.854,10.854,0,0,0-1.74.131,2.294,2.294,0,0,0-1.49.637,1.257,1.257,0,0,0,1.032,1.916,7.059,7.059,0,0,0,2.432.024,1.31,1.31,0,0,0,1.17-1.16A1.512,1.512,0,0,0,215.4,219.8Z",
    transform: "translate(-144.885 -181.828)",
    fill: "#1b1f2d"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(49.348 27.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M201.289,212.086c2.042-1.18,3.693-.225,3.7,2.107a8.079,8.079,0,0,1-3.675,6.365c-2.031,1.171-3.68.232-3.686-2.115a8.1,8.1,0,0,1,3.662-6.358",
    transform: "translate(-197.627 -211.58)",
    fill: "#1b1f2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M202.134,222.908l-3.549-2.08,5.084-9.044,3.681,2.144Z",
    transform: "translate(-197.376 -211.526)",
    fill: "#1b1f2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(3.734 2.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M204.248,213.811c2.042-1.18,3.692-.225,3.7,2.109a8.078,8.078,0,0,1-3.675,6.364c-2.029,1.172-3.679.232-3.686-2.115a8.1,8.1,0,0,1,3.662-6.358",
    transform: "translate(-200.586 -213.305)",
    fill: "#1b1f2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(3.942 2.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M204.206,213.995c1.927-1.112,3.483-.211,3.489,1.989a7.616,7.616,0,0,1-3.467,6c-1.914,1.105-3.472.22-3.478-2a7.642,7.642,0,0,1,3.455-6",
    transform: "translate(-200.751 -213.518)",
    fill: "#31394c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    transform: "translate(4.583 3.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M204.077,214.428c1.571-.957,2.841-.182,2.846,1.707a6.62,6.62,0,0,1-2.828,5.158c-1.561.95-2.831.188-2.836-1.714a6.635,6.635,0,0,1,2.818-5.151",
    transform: "translate(-201.259 -214.018)",
    fill: "none",
    stroke: "#546fbf",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M190.57,254.019l-.594,6.3q7.47-3.07,14.911-6.205A68.48,68.48,0,0,0,211.559,251a19.332,19.332,0,0,0,3.372-2.106,5.373,5.373,0,0,0,1.781-3.828c.1-.76.553-1.913,1.528-1.744.621.107.825.993,1.35.928a4.283,4.283,0,0,0,1.715-.92,7.4,7.4,0,0,1,1.733-1.035,4.1,4.1,0,0,1,2.113-.29.829.829,0,0,1,.456.207.365.365,0,0,1,.056.463,3.352,3.352,0,0,1,1.627-.077,1.294,1.294,0,0,1,.693.326.6.6,0,0,1,.116.711,3,3,0,0,1,1.156-.018,1.232,1.232,0,0,1,.883.685,1.913,1.913,0,0,1-.341,1.579,1.039,1.039,0,0,1,.674-.082.709.709,0,0,1,.444.564,1.343,1.343,0,0,1-.114.737,2.561,2.561,0,0,1-.522.8,5.1,5.1,0,0,1-.756.608c-1.137.8-2.215,1.624-3.39,2.369l-4.783,3.032c-3.358,2.128-6.913,4.105-10.123,6.442-3.157,2.3-6.475,4.453-9.8,6.508-4.679,2.887-9.489,5.959-14.612,8.008a6.344,6.344,0,0,1-2.232.621c-5.975,0-8.148-5.864-7.39-18.691Z",
    transform: "translate(-153.672 -175.697)",
    fill: "#f2c599"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M191.721,261.412s-5.29,3.115-15.6,3.274c0,0,.227-25.126,6.627-30.825S192.507,243.807,191.721,261.412Z",
    transform: "translate(-153.913 -178.13)",
    fill: "#db3e3e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M253.84,281.03c-7.842-1.678-35.224,5.625-35.224,5.625l-39.025-4.419s-3.311,16.275.155,22.795,13.066,10.3,22.372,13.2c16.188,5.034,44.7-18.185,44.7-18.185-.028.126-.048.247-.072.372h0l3.658,2.113c5.17,2.985,5.4,7.788.515,10.917l-3.271,2.095h0a85.833,85.833,0,0,1,1.37,25.9,1.9,1.9,0,0,0,.262,1.174,5.945,5.945,0,0,0,3.9,2.814,11.156,11.156,0,0,0,7.756-1.435,1.828,1.828,0,0,0,.876-1.45c.292-4.813,1.7-28.212,2.038-36.742C264.122,299.124,264.686,283.352,253.84,281.03Z",
    transform: "translate(-153.378 -165.527)",
    fill: "#31394c"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M179.585,281.933a82.173,82.173,0,0,0-1.4,12.059l19.08-10.057Z",
    transform: "translate(-153.372 -165.225)",
    fill: "#31394c"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M217.629,285.775l-3.863-2.23c-5.179-2.991-13.471-3.108-18.86-.268l-1.6.844,21.344,2.417S215.78,286.237,217.629,285.775Z",
    transform: "translate(-149.411 -165.411)",
    fill: "#2b3d89"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(24.787 116.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M246.749,300.112h0l3.228,1.864v-.006c.086-1.026.362-2,.5-3.012.074-.544.223-1.055-.192-1.5-.916-.987-2.778.087-3.7.454a107.907,107.907,0,0,0-12.535,5.984c-4.18,2.313-8.339,4.523-13.083,5.413a40.877,40.877,0,0,1-15.569.184c-4.934-1.032-11.985-4.043-14.741-8.357-3.419-5.349-2.843-17.265-2.843-17.265-.095-.365-.2-.71-.326-1.041l-7.9-.895s-3.311,16.275.155,22.795,13.066,10.3,22.372,13.2c16.188,5.034,44.7-18.185,44.7-18.185C246.793,299.866,246.773,299.987,246.749,300.112Z",
    transform: "translate(-178.164 -281.933)",
    fill: "#252c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M238.609,321.068c.058-5.077-1.165-9.713-2.1-14.41l-.009.006-3.271,2.095h0a85.834,85.834,0,0,1,1.37,25.9,1.9,1.9,0,0,0,.262,1.174,5.945,5.945,0,0,0,3.9,2.814c.254.043.492.057.737.083a23.6,23.6,0,0,1-.308-2.4C238.85,331.459,238.554,325.931,238.609,321.068Z",
    transform: "translate(-163.74 -275.456)",
    fill: "#252c3a"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M221.158,242.61s-6.276-7.93-12.144-10.7c0,0-4.144-.42-7.979-.7a12,12,0,0,1-5.852-2.159s-7.64,1.772-11.08,4.433c-3.607,2.791-7.053,16.432-5.644,27.48s.555,26.577,0,30.693c-1.068,7.89,6.469,15.216,16.363,15.917,12.981.922,27.44-2.227,26.971-8.676C220.771,284.861,221.158,242.61,221.158,242.61Z",
    transform: "translate(-153.385 -179.079)",
    fill: "#f24b4b"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M219.681,267.158l.257,6.444q7.47-3.07,14.913-6.205a67.438,67.438,0,0,0,6.671-3.117,19.193,19.193,0,0,0,3.373-2.106,5.369,5.369,0,0,0,1.779-3.826c.1-.758.553-1.913,1.53-1.745.621.107.824.993,1.349.93a4.307,4.307,0,0,0,1.716-.921A7.405,7.405,0,0,1,253,255.576a4.076,4.076,0,0,1,2.113-.29.833.833,0,0,1,.457.207.363.363,0,0,1,.054.463,3.341,3.341,0,0,1,1.628-.077,1.3,1.3,0,0,1,.693.326.6.6,0,0,1,.116.709,2.991,2.991,0,0,1,1.155-.016,1.233,1.233,0,0,1,.885.685,1.915,1.915,0,0,1-.342,1.579,1.031,1.031,0,0,1,.674-.082.711.711,0,0,1,.445.563,1.358,1.358,0,0,1-.115.738,2.534,2.534,0,0,1-.521.8,5.246,5.246,0,0,1-.756.608c-1.138.8-2.216,1.624-3.39,2.369q-2.393,1.514-4.784,3.031c-3.358,2.129-6.912,4.105-10.123,6.445-3.157,2.3-6.475,4.452-9.8,6.507-4.679,2.887-9.49,5.959-14.614,8.008a6.364,6.364,0,0,1-2.232.622c-5.974,0-8.48-6.542-7.722-19.369Z",
    transform: "translate(-145.906 -172.218)",
    fill: "#f2c599"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M222.162,271.858a43.181,43.181,0,0,1-16.891,4.678s-1.535-28.828,4.539-35.672S221.973,251.908,222.162,271.858Z",
    transform: "translate(-146.322 -176.373)",
    fill: "#db3e3e"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M160.564,256.706a.882.882,0,0,0,1.029-.077c.66,6.523,3.267,12.989,5.7,19.006,5.819,14.375,14.776,27.516,24.716,39.222,2.041,2.4,3.834,5.6,6.62,7.2a7.877,7.877,0,0,0,9.742-1.423,13.374,13.374,0,0,0,2.832-6.989,87.942,87.942,0,0,0,.507-20.29c-.533-6.192.265-12.766-1.972-18.7-1.882-4.99-5.82-9.044-10.1-12.086-4.484-3.184-9.539-5.394-14.441-7.828-4.383-2.177-8.815-5.259-13.763-5.912-3.14-.415-7.944-.517-10.527,1.687C159.034,252.118,158.171,255.24,160.564,256.706Z",
    transform: "translate(-158.371 -173.958)",
    fill: "#405dad"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(0 76.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M166.259,251.375,198.867,270.2a16.717,16.717,0,0,1,7.588,13.143l-.1,34.32c-.014,4.827-3.436,6.778-7.639,4.353l-32.607-18.826a16.734,16.734,0,0,1-7.589-13.143l.1-34.322c.014-4.838,3.438-6.777,7.639-4.352",
    transform: "translate(-158.523 -250.331)",
    fill: "#2b3d89"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M173.175,328.1l9.341,5.365-1.084-58.03a.94.94,0,0,0-.466-.794l-8.426-4.915a.939.939,0,0,0-1.412.811v54.026A4.08,4.08,0,0,0,173.175,328.1Z",
    transform: "translate(-155.221 -168.458)",
    fill: "#cfdeff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M186.865,318.692l-6.587-3.8-.541,4.593,2.61,2.112Z",
    transform: "translate(-152.966 -156.592)",
    fill: "#91aaf2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M189,330.652l-2.848,1.644c-2.052,1.186-3.725.232-3.732-2.126l-.1-54.869a1.523,1.523,0,0,0-.775-1.324l-8.157-4.609a1.08,1.08,0,0,0-1.03-.018l-.785.409a1.107,1.107,0,0,1,.848.055l8.1,4.761a1.52,1.52,0,0,1,.752,1.311l.1,54.884c.009,3.019,2.155,4.238,4.779,2.723l3.884-2.243Z",
    transform: "translate(-155.104 -168.553)",
    fill: "#a6bfff"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(63.685 126.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M218.263,323.715l-.825-.249-1.059-23.109,3.528-.424Z",
    transform: "translate(-207.052 -287.016)",
    fill: "#91aaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M217.9,324.444l-.12-24.013,6.788-3.283-1.454,24.29Z",
    transform: "translate(-206.686 -287.745)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M236.106,296v-1.99l-.781.262-1.023-2.263a1.036,1.036,0,0,0-.443-.448,2.656,2.656,0,0,0-2.413,0l-16.37,9.513-6.088,2.044v1.936h.005a.886.886,0,0,0,.5.668,2.216,2.216,0,0,0,.776.255l6.888,1.035c.559.324,5.256-1.879,10.488-4.92S236.667,296.323,236.106,296Z",
    transform: "translate(-208.988 -289.284)",
    fill: "#a6bfff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M233.859,289.987a2.66,2.66,0,0,0-2.413,0l-21.962,12.763c-.7.408-.621,1.032.01,1.4a2.193,2.193,0,0,0,.776.255l6.888,1.036c.559.323,5.256-1.88,10.488-4.92s9.021-5.77,8.46-6.093l-1.8-3.988a1.045,1.045,0,0,0-.443-.449",
    transform: "translate(-208.989 -289.697)",
    fill: "#cfdeff"
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M189.989,230.169l2.3-3.291a29.611,29.611,0,0,0,14.02,2.413l1.672,4.325S195.265,235.024,189.989,230.169Z",
    transform: "translate(-150.28 -179.647)",
    fill: "#db3e3e"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M202.885,219.875s1.285-9.5-2.837-13.919-11.876-6.426-14.12-4.548a7.8,7.8,0,0,1,4.354-4.211s16.243-4.96,17.1,19.706Z",
    transform: "translate(-151.344 -187.53)",
    fill: "#1b1f2d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactus);
export default __webpack_public_path__ + "static/media/contactus.2a0d9d0195f20f5253524e8a01ef09af.svg";
export { ForwardRef as ReactComponent };